import { CopyOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { copyToClipboard } from '../common/utils';

const RenderCopyIcon = ({
  copyText,
  toolTipText = 'Copy Order ID',
  zIndex = 4,
}) => {
  if (!copyText) {
    return null;
  }
  return (
    <Tooltip title={toolTipText} placement="top" zIndex={zIndex}>
      <CopyOutlined
        className="mr-8 cursor-pointer"
        onClick={(e) => copyToClipboard(e, copyText)}
      />
    </Tooltip>
  );
};

export default RenderCopyIcon;
